import { styled } from '~/stitches.config';

export const Container = styled('ol', {
  marginLeft: 0,

  listStyle: 'none',
});
